var _rect, _line, _line2, _line3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 14,
    height: 13,
    rx: 1.5,
    stroke: "#2773FF"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.5,
    y1: 6,
    x2: 3.5,
    y2: 12,
    stroke: "#2773FF"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 11.5,
    y1: 6,
    x2: 11.5,
    y2: 12,
    stroke: "#2773FF"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 7.5,
    y1: 3,
    x2: 7.5,
    y2: 12,
    stroke: "#2773FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/Report.f54a177b1e52039e20c497a9a1faf476.svg";
export { ForwardRef as ReactComponent };